import { render, staticRenderFns } from "./AsociarEventosForm.vue?vue&type=template&id=2024538a&scoped=true&"
import script from "./AsociarEventosForm.vue?vue&type=script&lang=ts&"
export * from "./AsociarEventosForm.vue?vue&type=script&lang=ts&"
import style0 from "./AsociarEventosForm.vue?vue&type=style&index=0&id=2024538a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2024538a",
  null
  
)

export default component.exports